import { useState, useEffect } from "react";
import { AiOutlineArrowUp, AiOutlineArrowDown } from "react-icons/ai";
import "../assets/css/components.css";
import { MdOutlineNavigateNext, MdOutlineNavigateBefore } from "react-icons/md";
import { AvailablePaxListTableColumns } from "../constants/availablePaxListTableColumns";

export const TableListAvailable = ({ list, rowsPerPage = 10 }) => {
  const [dataList, setDataList] = useState([]);
  const [filteredDataList, setFilteredDataList] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredDataList.length / rowsPerPage);
  const startRow = (currentPage - 1) * rowsPerPage;
  const paginatedData = filteredDataList.slice(
    startRow,
    startRow + rowsPerPage
  );
  const applyFilters = () => {
    setFilteredDataList(
      dataList.filter((data) => Object.keys(data).some((key) => data[key]))
    );
  };
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    const sortedList = [...filteredDataList].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "ascending" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
    setFilteredDataList(sortedList);
    setSortConfig({ key, direction });
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        return <AiOutlineArrowUp />;
      } else {
        return <AiOutlineArrowDown />;
      }
    }
    return null;
  };
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const renderPagination = () => {
    const maxVisiblePages = 5;
    const pageNumbers = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    if (startPage > 1) {
      pageNumbers.push(
        <button key={1} type="button" onClick={() => handlePageChange(1)}>
          1
        </button>
      );
      if (startPage > 2) {
        pageNumbers.push(<span key="start-ellipsis">...</span>);
      }
    }
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          type="button"
          onClick={() => handlePageChange(i)}
          className={currentPage === i ? "active" : ""}
        >
          {i}
        </button>
      );
    }
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(<span key="end-ellipsis">...</span>);
      }
      pageNumbers.push(
        <button
          key={totalPages}
          type="button"
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </button>
      );
    }
    return pageNumbers;
  };
  useEffect(() => {
    setDataList(
      [...list].sort((a, b) => {
        const dateA = new Date(a.lastModifiedDate);
        const dateB = new Date(b.lastModifiedDate);
        return dateB - dateA;
      })
    );
  }, [list]);
  useEffect(() => {
    applyFilters();
  }, [dataList]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filteredDataList]);

  return (
    <div>
      <table className="table-list">
        <thead>
          <tr>
            <th>NO</th>
            {AvailablePaxListTableColumns.map((column) => (
              <th
                className="clickable-text"
                onClick={() => handleSort(column.key)}
                key={column.key}
              >
                {column.label} {renderSortIcon(column.key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedData.length === 0 ? (
            <tr>
              <td colSpan={AvailablePaxListTableColumns.length + 1}>
                No Records Found
              </td>
            </tr>
          ) : (
            paginatedData.map((data, index) => (
              <tr key={data.id ?? index}>
                <td>{startRow + index + 1}</td>
                {AvailablePaxListTableColumns.map((column) => (
                  <td key={column.key}>
                    {column.key === "timeSlot" ? (
                      `${data[column.key].startTime} - ${
                        data[column.key].endTime
                      }`
                    ) : column.key === "availablePax" ||
                      column.key === "activePax" ? (
                      <div
                        className={
                          data[column.key] >= Math.ceil(data["maxPax"] / 2)
                            ? "green-text"
                            : data[column.key] < Math.floor(data["maxPax"] / 4)
                            ? "red-text"
                            : "orange-text"
                        }
                      >
                        {data[column.key]}
                      </div>
                    ) : (
                      data[column.key]
                    )}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="pagination-controls">
        <button
          type="button"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <MdOutlineNavigateBefore />
        </button>
        {renderPagination()}
        <button
          type="button"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <MdOutlineNavigateNext />
        </button>
      </div>
    </div>
  );
};
